/** @jsx h */
import { labels } from '../../config';
import { useRef, useEffect } from 'preact/hooks';

const Pagination = ({ pagination, loadMore, pluginNamespace }) => {
  const paginationInputEl = useRef(null);

  useEffect(() => {
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = '';
    }
  }, []);

  function handleLoadMoreClick(event) {
    event && event.preventDefault();
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = pagination.current + 1;
      loadMore();
    }
  }

  /* Only show load more button, if there is something to load */
  if (
    pagination &&
    (pagination.current === pagination.numberOfPages ||
      pagination.numberOfPages === 0)
  ) {
    return '';
  }

  return (
    <div className="search__pagination">
      <input
        type="text"
        name={`${pluginNamespace}[page]`}
        hidden
        readonly
        ref={paginationInputEl}
      />
      <button
        className="btn btn--primary btn--icon"
        type="button"
        onClick={handleLoadMoreClick}
      >
        <span>{labels.pagination.loadMore}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-plus"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M 10.4,13.6 H 1.6 C 1.2,13.6 0.8,13.4 0.5,13.1 0.2,12.8 0,12.4 0,12 0,11.6 0.2,11.2 0.5,10.9 0.8,10.6 1.2,10.4 1.6,10.4 h 8.8 V 1.6 C 10.4,1.2 10.6,0.8 10.9,0.5 11.2,0.2 11.6,0 12,0 c 0.4,0 0.8,0.2 1.1,0.5 0.3,0.3 0.5,0.7 0.5,1.1 v 8.8 h 8.8 c 0.4,0 0.8,0.2 1.1,0.5 0.3,0.3 0.5,0.7 0.5,1.1 0,0.4 -0.2,0.8 -0.5,1.1 -0.3,0.3 -0.7,0.5 -1.1,0.5 h -8.8 v 8.8 c 0,0.4 -0.2,0.8 -0.5,1.1 -0.3,0.3 -0.7,0.5 -1.1,0.5 -0.4,0 -0.8,-0.2 -1.1,-0.5 -0.3,-0.3 -0.5,-0.7 -0.5,-1.1 0,0 0,-8.8 0,-8.8 z"
          />
        </svg>
      </button>
    </div>
  );
};

export default Pagination;
